import {Badge, Button, Divider, Dropdown, Space, Typography} from "antd";
import { useNavigate } from "react-router-dom";
import style from "./ResponsiveNotification.module.scss";
import {BellOutlined, LoginOutlined} from '@ant-design/icons';
import {connect} from "react-redux";
import {getNotification} from "../../../../notification/actions/Notification.action";
import {withRouter} from "../../../../../utils/services/with-router";
import {ResponsiveNotificationProps} from "../../../models";
import React, {useEffect, useState} from "react";
import {StyledBellOutlined} from "./ResponsiveNotification.styled";
const { Text } = Typography;

function ResponsiveNotification( {getNotification} : ResponsiveNotificationProps) {
  const navigate = useNavigate();
    const loggedIN = !!localStorage.getItem("jwt");
    const [notificationCount, setNotificationCount] = useState<any[]>([]);

    const _getNotification = () => {
        getNotification()
            .then((data: any) => {
                if (data.payload != undefined) {
                    setNotificationCount(data.payload.data.filter((item :any) => item.seenAt === null).length);

                }
            })
            .catch((e: any) => {
            });
    };

    useEffect(() => {
        if (!!localStorage.getItem("jwt"))
        _getNotification()
    }, [localStorage]);
    return (

    <Dropdown
      arrow
      trigger={["click"]}
      dropdownRender={(menu) => (
        <div
          style={{
            padding: "12px 8px",
            // background: "var(--bs-gray-100)",
            background: "white",
            boxShadow: "1px 1px 4px var(--bs-gray-200)",
            borderRadius: 4,
          }}
        >

        </div>
      )}
    >
        {loggedIN ? <Badge count={notificationCount}>  <StyledBellOutlined
            className={style.menuIcon}
            onClick={(e) => {
                e.preventDefault()
                navigate("/notification")
            }
            }
        /> </Badge> :  <Button shape="circle" onClick={(e) => e.preventDefault()}>
        <LoginOutlined
            className={style.menuIcon}
            onClick={(e) => {
                e.preventDefault()
                navigate("/login")
            }
            }
        />
    </Button> }
    </Dropdown>

  );
}

export default connect(null, {getNotification})(
    withRouter(ResponsiveNotification)
);
